<script lang="ts">
  import { userSettings, settingsActions } from '../../stores/settings';
  import { _ } from 'svelte-i18n';
  import { setAppLocale } from '../../lib/i18n';

  let { open, onClose } = $props<{ open: boolean; onClose: () => void }>();

  const languageOptions = [
    { value: 'cs', labelKey: 'language.names.cs', flag: '🇨🇿' },
    { value: 'ar', labelKey: 'language.names.ar', flag: '🇸🇦' },
    { value: 'en', labelKey: 'language.names.en', flag: '🇬🇧' },
  ];

  const handleClose = () => {
    onClose();
  };

  const handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      handleClose();
    }
  };
</script>

{#if open}
  <div class="fixed inset-0 z-[96] flex flex-col bg-background"   
      role="dialog"
      aria-modal="true"
      tabindex="0"
      onkeydown={handleKeydown}
      >

    <div class="flex items-center justify-between px-6 pt-6">
      <div>
        <p class="section-label text-xs tracking-[0.28em] text-muted-foreground">{$_('settings.language.primary_label')}</p>
        <h2 class="section-title mb-2">{$_('language.select_language')}</h2>
      </div>
      <button
        class="btn btn-close"
        onclick={handleClose}
        aria-label={$_('language.dialog.close_label')}
      >
        <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto px-6 pb-16">
      <div class="space-y-4 pt-6">
        <div class="grid gap-3">
          {#each languageOptions as lang (lang.value)}
            <button
              class={`flex items-center justify-between rounded-2xl border px-4 py-4 text-left transition hover:border-primary/40 hover:bg-primary/10 ${
                ($userSettings?.preferred_language || 'cs') === lang.value
                  ? 'border-primary/60 bg-primary/20 shadow-soft-sm'
                  : ''
              }`}
              onclick={async () => {
                await settingsActions.updateSetting('preferred_language', lang.value as 'cs' | 'ar' | 'en');
                setAppLocale(lang.value);
                handleClose();
              }}
            >
              <div class="flex items-center gap-3">
                <div class="h-8 w-12 rounded-lg overflow-hidden shadow-soft-sm flex-shrink-0">
                  <img
                    src={`https://flagcdn.com/${lang.value === 'en' ? 'gb' : lang.value === 'ar' ? 'sa' : 'cz'}.svg`}
                    alt={$_(lang.labelKey)}
                    class="h-full w-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p class="text-base font-semibold">{$_(lang.labelKey)}</p>
                  <p class="text-sm">{lang.flag}</p>
                </div>
              </div>
              {#if ($userSettings?.preferred_language || 'cs') === lang.value}
                <span class="rounded-full bg-primary/80 px-3 py-1 text-xs font-semibold">{$_('language.status.selected')}</span>
              {/if}
            </button>
          {/each}
        </div>
      </div>
    </div>
  </div>
{/if}
